import axios from 'axios'

var instance = axios.create({
  timeout: 12 * 1000
})
instance.defaults.headers.post['Content-Type'] = 'application/json; charset=utf-8'

// 请求拦截器

instance.interceptors.request.use(
  config => {
    // post序列化传参
    /* if(config.method === 'post'){
        config.data = QS.stringify(config.data)
    } */
    if (localStorage.getItem('Authorization')) {
      config.headers.common['token'] = localStorage.getItem('Authorization')
    }
    return config
  }
)

// 封装post请求
// @param {String} url [请求的url地址]
// @param {Object} params [请求的参数]

export function post (url, params) {
  return new Promise(function (resolve, reject) {
    instance.post(url, params).then(res => {
      resolve(res)
    }).catch(err => {
      reject(err)
    })
  })
}

// get方法，对应get请求
// @param {String} url [请求的url地址]
// @param {Object} params [请求时携带的参数]

export function get (url, params) {
  return new Promise(function (resolve, reject) {
    instance.get(url, {
      params: params
    }).then(res => {
      resolve(res)
    }).catch(err => {
      reject(err)
    })
  })
}

// 响应拦截器
instance.interceptors.response.use(
  response => {
    if (response.status === 200) {
      return Promise.resolve(response)
    } else {
      return Promise.reject(response)
    }
  },
  error => {
    console.log(error, 'error')
    if (error && error.response) {
      if (error.response.status === 403 || error.response.status === 401) {
      }
    }
    return Promise.reject(error)
  }
)

export default {get, post}



// WEBPACK FOOTER //
// ./src/request/request.js